<template>
    <div>
      <v-row no-gutters>
        <v-col cols="12">
          <v-card
            elevation="0"
            outlined
            @drop.prevent="onDrop($event)"
            @dragover.prevent="dragover = true"
            @dragenter.prevent="dragover = true"
            @dragleave.prevent="dragover = false"
          >
            <v-card-text>
              <v-row
                class="d-flex flex-column"
                dense
                align="center"
                justify="center"
              >
                <v-icon :class="[dragover ? 'mt-2, mb-6' : 'mt-5']" size="40">
                  mdi-cloud-upload
                </v-icon>
                <p>
                  <a @click="$refs['file'].click()">{{
                    $t("Drop your file(s) here, or click to select them.")
                  }}</a>
                </p>
              </v-row>
              <v-virtual-scroll
                v-if="uploadedFiles.length > 0"
                :items="uploadedFiles"
                height="150"
                item-height="50"
              >
                <template v-slot:default="{ item }">
                  <v-list-item :key="item.name">
                    <v-list-item-content>
                      <v-list-item-title class="mr-4">
                        <v-row no-gutters>
                          <v-col>
                            <v-layout fill-height align-center>
                              {{ item.name }}
                            </v-layout>
                          </v-col>
                          <v-col>
                            <div v-if="usage == 'newTicket'">
                              <v-img
                                max-height="50"
                                max-width="50"
                                v-if="item['type'].includes('image')"
                                :src="getUrlFromItem(item)"
                              ></v-img>
                            </div>
                            <v-img
                              max-height="50"
                              max-width="50"
                              :src="getUploadedImages(item)"
                              v-if="usage == 'editTicket'"
                            ></v-img>
                          </v-col>
                        </v-row>
                      </v-list-item-title>
                    </v-list-item-content>
  
                    <v-list-item-action>
                      <v-layout>
                        <v-btn
                          :loading="loadingItemInNewTab"
                          @click="openImadeInNewTab(item)"
                          icon
                          v-if="usage != 'newTicket'"
                        >
                          <v-icon> mdi-eye-arrow-right </v-icon>
                        </v-btn>
                        <v-btn
                          :loading="loadingDelete"
                          @click.stop="removeFile(item)"
                          icon
                        >
                          <v-icon> mdi-close-circle </v-icon>
                        </v-btn>
                      </v-layout>
                    </v-list-item-action>
                  </v-list-item>
  
                  <v-divider></v-divider>
                </template>
              </v-virtual-scroll>
            </v-card-text>
          </v-card>
  
          <input
            ref="file"
            type="file"
            multiple="multiple"
            style="display: none"
            label="upload file"
            @change="loadFiles($event)"
          />
        </v-col>
      </v-row>
    </div>
  </template>
  
  <script>
  import request from "@/request";
  export default {
    props: ["usage", "ticketId", "parentFiles", "coNumber"],
    data() {
      return {
        dragover: null,
        uploadedFiles: [],
        filesName: [],
        multiple: true,
        keyitem: null,
        loadingDelete: null,
        loadingItemInNewTab: null,
      };
    },
    watch: {
      parentFiles(newValue) {
        this.uploadedFiles = [];
        if (newValue) {
          if (newValue.length > 0) {
            for (let i = 0; i < newValue.length; i++) {
              this.uploadedFiles.push({ name: newValue[i] });
            }
          }
        }
      },
    },
    created() {
      if (this.parentFiles) {
        if (this.parentFiles.length > 0) {
          for (let i = 0; i < this.parentFiles.length; i++) {
            this.uploadedFiles.push({ name: this.parentFiles[i] });
          }
        }
      }
    },
  
    methods: {
      removeFile(file) {
        this.loadingDelete = true;
  
        if (this.usage == "newTicket") {
          this.removeFileOutOfArray(file.name);
        } else if (this.usage == "editTicket") {
          this.removeFileFromServer(file);
        }
      },
      removeFileOutOfArray(fileName) {
        // Find the index of the
        const index = this.uploadedFiles.findIndex(
          (file) => file.name === fileName
        );
        // If file is in uploaded files remove it
        if (index > -1) this.uploadedFiles.splice(index, 1);
        //update parent component
        this.$emit("deleteItemOutOfFile", { use: this.usage, value: fileName });
        this.loadingDelete = false;
      },
      removeFileFromServer(item) {
        request.post(
          "/api/com-one/remove-file?ticketId=" +
            this.ticketId +
            "&fileName=" +
            item.name,
          null,
          () => {
            const index = this.uploadedFiles.findIndex(
              (file) => file.name === item.name
            );
            // If file is in uploaded files remove it
            if (index > -1) this.uploadedFiles.splice(index, 1);
            this.loadingDelete = false;
          }
        );
      },
      loadFiles(e) {
        let formData = new FormData();
  
        for (let i = 0; i < e.target.files.length; i++) {
          formData.append("files", e.target.files[i]);
          this.filesName.push(e.target.files[i].name);
          this.uploadedFiles.push(e.target.files[i]);
        }
        if (this.ticketId) {
          this.loadingItemInNewTab = true;
          request.post(
            "/api/com-one/upload-file?ticketId=" + this.ticketId,
            formData,
            () => {
              this.loadingItemInNewTab = false;
            }
          );
        } else {
          this.$emit("updateFiles", { use: this.usage, value: e.target.files });
        }
      },
      onDrop(e) {
        this.dragover = false;
        let formData = new FormData();
        for (var i = 0; i < e.dataTransfer.files.length; i++) {
          formData.append("files", e.dataTransfer.files[i]);
          this.filesName.push(e.dataTransfer.files[i].name);
          this.uploadedFiles.push(e.dataTransfer.files[i]);
        }
        if (this.ticketId) {
          request.post(
            "/api/com-one/upload-file?ticketId=" + this.ticketId,
            formData,
            () => {}
          );
        }
        this.$emit("updateFiles", {
          use: this.usage,
          value: e.dataTransfer.files,
        });
      },
      openImadeInNewTab(item) {
        window
          .open(
            window.location.protocol +
              "//" +
              window.location.host +
              "/files/" +
              this.coNumber +
              "/" +
              item.name+"?token="+JSON.parse(localStorage.user).Token.replace("Bearer ", ""),
            "_blank"
          )
          .focus();
      },
      getUrlFromItem(item) {
        return URL.createObjectURL(item);
      },
      getUploadedImages(item) {
        let image = "";
        const ext = item.name.split(".");
        if (
          ext[1] == "svg" ||
          ext[1] == "png" ||
          ext[1] == "jpg" ||
          ext[1] == "jpeg" ||
          ext[1] == "jfif" ||
          ext[1] == "pjpeg" ||
          ext[1] == "pjp"
        ) {
          image =
            window.location.protocol +
            "//" +
            window.location.host +
            "/files/" +
            this.coNumber +
            "/" +
            item.name;
        }
        return image;
      },
    },
  };
  </script>
  
  <style scoped>
  .cursor-pointer {
    cursor: pointer;
  }
  </style>